import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Team } from "src/app/shared/models/team";

@Injectable({
  providedIn: "root",
})
export class TeamService {
  constructor(private http: HttpClient) {}

  apiRoot = `${environment.apiUrl}Team`;

  public createTeam(code: string, description: string): Observable<Team> {
    return this.http.post<Team>(
      `${this.apiRoot}/createTeam/code=${code}/description=${description}`,
      null
    );
  }

  public getTeam(code: string): Observable<Team> {
    return this.http.get<Team>(`${this.apiRoot}/getTeam/${code}`);
  }

  public getAllTeams(): Observable<Team[]> {
    return this.http.get<Team[]>(`${this.apiRoot}/getAllTeams`);
  }

  public deleteTeam(code: string): Observable<Team> {
    return this.http.delete<Team>(`${this.apiRoot}/deleteTeam/${code}`);
  }
}
